"use client";

import React from "react";
import { createIcon } from "@chakra-ui/react";

const _555bfIcon = createIcon({
  displayName: "_555bfIcon",
  viewBox: "0 0 500 500",
  path: (
    <>
      <path d="m74.941 219.813h61.192v61.192h-61.192z" fill="currentColor" />
      <path d="m75.247 305.481h61.193v61.191h-61.193z" fill="currentColor" />
      <path d="m75.4 391.149h61.192v61.192h-61.192z" fill="currentColor" />
      <path d="m74.865 134.144h61.192v61.192h-61.192z" fill="currentColor" />
      <path d="m74.827 48.474h61.191v61.192h-61.191z" fill="currentColor" />
      <path
        d="m413.248 249.918c4.928-76.658 73.934-190.163-58.734-190.163-111.137 0-118.595 96.192-118.595 190.163 0 84.969 4.044 186.586 106.527 190.163 142.87 4.986 76.279-104.975 70.802-190.163z"
        fill="currentColor"
      />
    </>
  ),
  defaultProps: {
    boxSize: "1em",
  },
});

export default _555bfIcon;
